export default class TabSemRotaUtils {
	id = null
	titulo = 'tab-default'
	slot = 'slot'
	contador = 0
	corIcone = 'orange'
	msgIcone = ''

	constructor(id, titulo, slotName, isVisible, contador, msgIcone) {
		this.id = id
		this.titulo = titulo
		this.slot = slotName
		this.contador = contador
		this.msgIcone = msgIcone
		if (isVisible !== undefined) this.isVisible = isVisible
	}

	isVisible = () => {
		return true
	}
}
